const globalName = 'ga';

// Keeping the API/params consistent, we still provide isLast, even
// though it is not used for the google-analytics setup, thus eslint-disable
// eslint-disable-next-line no-unused-vars
function initialize(trackerConfig, count, isLast = true) {
  const trackerEndpoint = (trackerConfig.url)
    ? trackerConfig.url
    : 'https://www.google-analytics.com/analytics.js';

  // load the 3rdparty-script only once, before setting up the first instance
  if (count === 0) {
    /* eslint-disable */
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script',trackerEndpoint,globalName);
    /* eslint-enable */
  }

  // for all trackers, add them to the ga-object
  window[globalName]('create', trackerConfig.trackerId, 'auto', trackerConfig.name);

  return {
    set(param, value) {
      window[globalName]('set', param, value);
    },

    setDimension(id, value) {
      window[globalName]('set', `dimension${id}`, value);
    },

    trackEvent(category, action, options) {
      const eventLabel = options.label || '';
      const eventValue = (options.value) ? parseInt(options.value, 10) : undefined;
      const nonInteraction = (options && options.nonInteraction)
        ? options.nonInteraction
        : false;

      window[globalName](`${trackerConfig.name}.send`, 'event', {
        eventCategory: category,
        eventAction: action,
        eventLabel,
        eventValue,
        nonInteraction,
        transport: 'beacon',
      });
    },

    trackPageView() {
      window[globalName](`${trackerConfig.name}.send`, 'pageview');
    },
  };
}

export default {
  initialize,
};
